import scoutingNavItems from "./scoutingNavItems"
import { NavItemType } from "types/menu"

const scoutingMenuItems: { items: NavItemType[] } = {
  items: [scoutingNavItems]
}

export default scoutingMenuItems
